<template>
  <div class="cases-index" :style="{ height: height }">
    <div class="content">
      <div
        class="case-title"
        v-scroll-animate="{
          animation: 'fadeInDown',
          observerOnce: false,
          duration: 600,
          delay: 200,
        }"
      >
        <div v-for="(item, index) in title" :key="'case_title_' + index">
          {{ item }}
        </div>
      </div>
      <!-- tab栏 -->
      <ul
        class="trigger-box"
        v-scroll-animate="{
          animation: 'bounceInLeft',
          delay: 300,
        }"
      >
        <li
          class="trigger-item"
          :class="sliderIndex === index ? 'active' : ''"
          v-for="(item, index) in lists"
          :key="index"
          @click="goTo(index)"
        >
          <div class="trigger-label">
            {{ item.name }}
          </div>
        </li>
      </ul>
      <!-- 轮播内容 -->
      <div
        class="carouselBody"
        v-scroll-animate="{
          animation: 'bounceInRight',
          delay: 300,
        }"
      >
        <div class="title">
          {{ lists[sliderIndex].case.title || "" }}
        </div>
        <div class="subTitle text-wrap">
          {{ lists[sliderIndex].case.description || "" }}
        </div>
        <button
          v-if="isShowMore"
          class="learnMore"
          @click="openUrl(lists[sliderIndex])"
        >
          了解更多 >
        </button>
      </div>
    </div>
    <el-carousel
      ref="myCarousel"
      :direction="direction"
      indicator-position="none"
      :loop="loop"
      :height="height"
      :autoplay="autoplay"
      :interval="interval"
      @change="handerChange"
    >
      <el-carousel-item v-for="(item, index) in lists" :key="index">
        <img class="c_img" :src="item.picUrl" alt="轮播图" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: "VerticalBanner",
  props: {
    height: {
      type: String,
      default: () => {
        return "584px";
      },
    },
    title: {
      type: Array,
      default: () => {
        return [
          "基础设施建设行业对该狄诺尼有着高度的信赖，",
          "这使得我们成为业内备受推崇且值得信赖的企业。",
        ];
      },
    },
    // 指示器的位置
    // indicatorPosition: {
    //   type: String,
    //   default: () => {
    //     return "outside"; // none
    //   },
    // },
    // 方向
    direction: {
      type: String,
      default: () => {
        return "vertical"; // horizontal
      },
    },
    // 是否循环显示
    loop: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    // 是否自动滚动
    autoplay: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    // 间隔时间
    interval: {
      type: Number,
      default: () => {
        return 8000;
      },
    },
    // 查看更多
    isShowMore: {
      type: Boolean,
      default: () => {
        return true;
      },
    },

    lists: {
      type: Array,
      default: () => {
        return [
          {
            name: "高速公路",
            value: "expressway",
            picUrl: require(`@/assets/images/intelligentImg/bg-jgpt-case-expressway.png`),
            bannerLink:
              "/intelligent/management/caseDetail?anchor=Cases&type=expressway",
            case: {
              title:
                "沪武高速公路（江苏段）改扩建工程BIM建管平台构建与应用研究",
              description:
                "狄诺尼通过BIM建管平台为沪武高速公路（江苏段）的建设管理提供了全过程的数字化支持，实现了对项目进度、质量、安全及投资的全要素动态管控，有效提升了多参与方协同效率与工程建设的精细化管理水平，助力打造品质工程。 ",
            },
          },
          {
            name: "桥梁",
            value: "bridge",
            picUrl: require(`@/assets/images/intelligentImg/bg-jgpt-case-bridge.png`),
            bannerLink:
              "/intelligent/management/caseDetail?anchor=Cases&type=bridge",
            case: {
              title:
                "张靖皋长江大桥BIM协同建设管理平台：数据驱动下的特大桥梁工程数字化实践",
              description:
                "狄诺尼通过BIM协同建设管理平台为项目建设的精细化管理提供技术支持，并通过新技术手段实现对整个施工过程及所有要素的数字化管理。",
            },
          },
          {
            name: "隧道",
            value: "tunnel",
            picUrl: require(`@/assets/images/intelligentImg/bg-jgpt-case-tunnel.png`),
            bannerLink:
              "/intelligent/management/caseDetail?anchor=Cases&type=tunnel",
            case: {
              title: "海太长江隧道智慧建设BIM协同管理平台",
              description:
                "狄诺尼通过智慧建设BIM协同管理平台，为海太长江隧道这一世界级水下盾构工程构建了数字孪生底座，实现施工过程的可视化模拟、关键风险的智能预警与盾构设备的协同管控，推动项目建设向数字化、智慧化方向转型升级。 ",
            },
          },
          {
            name: "轨道交通",
            value: "rail",
            picUrl: require(`@/assets/images/intelligentImg/bg-jgpt-case-rail.png`),
            bannerLink:
              "/intelligent/management/caseDetail?anchor=Cases&type=rail",
            case: {
              title:
                "某地级城市轨道交通设计项目：AI驱动的智能化三维正向设计实践",
              description:
                "狄诺尼通过BIM协同建设管理平台为项目建设的精细化管理提供技术支持，并通过新技术手段实现对整个施工过程及所有要素的数字化管理。 ",
            },
          },
          {
            name: "公共设施",
            value: "facilities",
            picUrl: require(`@/assets/images/intelligentImg/bg-jgpt-case-facilities.png`),
            bannerLink:
              "/intelligent/management/caseDetail?anchor=Cases&type=facilities",
            case: {
              title: "污水治理建管养一体化平台",
              description:
                "狄诺尼为美丽乡村的农污治理提供基础设施建设过程全要素数字化基础平台，针对总承包过程中设计，施工，运维的痛点，本平台了集成管网GIS、质量管理、安全管理、物资管控、文档管理、计划进度管理、计量支付管理等多个模块。农村污水治理建管养一体化平台”为高质量推进农村生活污水建设，运行和管理，打赢农村水环境势力的攻坚战的工作提供重要支撑。",
            },
          },
          {
            name: "更多行业",
            value: "more",
            picUrl: require(`@/assets/images/intelligentImg/bg-jgpt-case-more.png`),
            bannerLink:
              "/intelligent/management/caseDetail?anchor=Cases&type=more",
            case: {
              title:
                '徐圩港区疏港航道整治工程数字化建设管理平台：打造"水运江苏"智慧建设新标杆',
              description:
                "狄诺尼通过构建贯穿项目全生命周期的建设管理平台，为公路、市政、港口航道、水利及环境环保等重大基础设施提供数字化基石。平台致力于实现对工程“建、管、养、运”全过程的精准管控与智慧决策，通过数据驱动提升质量安全、降本增效和绿色低碳水平，赋能基础设施高质量发展。",
            },
          },
        ];
      },
    },
  },
  components: {},
  data() {
    return {
      sliderIndex: 0,
      routePath: "",
    };
  },
  computed: {},
  created() {
    console.log("this.lists--", this.lists);
    this.routePath = this.$route.path;
  },
  mounted() {},
  methods: {
    openUrl(item) {
      if (item.bannerLink) {
        this.$uniFun.openInCurrentTab(item.bannerLink);
      }
    },
    handerChange(index) {
      console.log("handerChange", index);
      this.sliderIndex = index;
    },
    goTo(index) {
      this.$refs.myCarousel.setActiveItem(index);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/common.scss";
.cases-index {
  background: #232323;
  position: relative;

  .content {
    width: 1049px;
    height: 100%;
    margin: 0 auto;
    padding: 40px 0;
    box-sizing: border-box;
    z-index: 10;
    position: relative;
    .case-title {
      font-size: 18px;
      line-height: 32px;
      color: #ffffff;
      margin-top: 16px;
    }
    .carouselBody {
      width: calc(100% - 150px);
      position: absolute;
      top: 150px;
      left: 150px;
      color: #ffffff;
      .title {
        font-size: 24px;
        line-height: 24px;
        margin-bottom: 16px;
        font-weight: 600;
        color: #ffffff;
      }
      .subTitle {
        font-size: 16px;
        line-height: 32px;
        color: #ffffff;
        text-align: justify;
      }
      .learnMore {
        margin-top: 40px;
        padding: 8px 16px;
        background: rgba(0, 53, 251, 1);
        font-size: 14px;
        line-height: 14px;
        font-weight: 600;
        color: #ffffff;
        cursor: pointer;
        margin-top: 40px;
        z-index: 10;
        &:hover {
          opacity: 0.8;
        }
      }
    }

    .trigger-box {
      position: absolute;
      top: 150px;
      // left: 250px;
      width: 112px;
      background-color: rgba(255, 255, 255, 0.1);
      backdrop-filter: blur(10px); /* 模糊背景 */
      z-index: 10;
      .trigger-item {
        cursor: pointer;
        text-align: right;
        .trigger-label {
          width: 100%;
          height: 40px;
          font-size: 16px;
          line-height: 40px;
          color: #ffffff;
          text-align: center;
          cursor: pointer;
          margin-top: 16px;
          &:last-child {
            margin-bottom: 16px;
          }
        }
        &.active {
          border-left: 2px solid rgba(43, 148, 252, 1);
          .trigger-label {
            color: rgba(43, 148, 252, 1);
          }
        }
      }
    }
  }
  .el-carousel {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  .c_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}
</style>
